<template>
  <div class="btn-group" ref="dropdownFilter">
    <div @click="toggleMenu()" class="dropdown-toggle"
    v-if="selected && selected.name !== undefined">
      <span class="selected-name label">
        {{ selectedOption.name }}
      </span>
      <svgicon name="dbcategorydropdown" v-if="options.length>1"
        class="dropdown-icon" width="11.23" height="18" :original="true" />
    </div>
    <ul class="dropdown-menu dark-dropdown-menu" v-if="showMenu && options.length>1">
      <li v-for="option in options" v-bind:key="option.id">
        <a href="javascript:void(0)" @click="updateOption(option)">
        {{ option.name }}
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      selectedOption: {
        name: null,
      },
      showMenu: false,
      placeholderText: 'Please select an item',
    };
  },
  props: {
    options: {
      type: [Array, Object],
    },
    selected: {},
  },
  created() {
    this.selectedOption = this.selected;
    document.addEventListener('click', this.documentClick);
  },
  destroyed() {
    document.removeEventListener('click', this.documentClick);
  },
  methods: {
    updateOption(option) {
      this.selectedOption = option;
      this.showMenu = false;
      this.$emit('updateOption', this.selectedOption);
    },
    toggleMenu() {
      if (this.options.length > 1) {
        this.showMenu = !this.showMenu;
      }
    },
    documentClick(event) {
      const el = this.$refs.dropdownFilter;
      const target = event.target;
      if ((el !== target) && !el.contains(target)) {
        this.showMenu = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>

</style>
